<template>
  <div>
    <datatable
      title="Outsource"
      :is_createable="false"
      :show_delete="false"
      :operations="operations"
      @expire="expire"
      @showslots="showSlots"
      @edit_click="editClick"
      @inactive_hot_positions="showInactiveHotPositions"
      :filters="filters"
      :fields="fields"
      :response="data"
      :unique_buttons="unique_buttons"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import FiltersHelper from '@/custom/classes/filters_helper.js'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-outsource',
  data () {
    return {
      env: this.$settings.get({ path: 'operation_name' }),
      filters_helper: new FiltersHelper(),
      fields: [
        {
          name: 'status',
          value: 'status'
        },
        {
          name: 'title',
          value: 'title',
          component: 'OutsourcePositionLinkEntity'
        },
        {
          name: 'company',
          value: 'company',
          component: 'OutsourceCompanyLinkEntity'
        },
        {
          name: 'priority',
          value: 'priority'
        },
        {
          name: 'publish_outsources',
          value: 'publish_outsources'
        },
        {
          name: 'created_at',
          value: 'created_at',
          is_time: true
        }
      ],
      filters: [
        {
          type: 'single',
          designator: 'status',
          options: [
            {
              text: 'active',
              value: 'active'
            },
            {
              text: 'expired',
              value: 'expired'
            }
          ]
        }
      ],
      data: [],
      operations: [
        { name: 'expire' },
        { name: 'showSlots' }
      ],
      unique_buttons: [
        { name: 'inactive_hot_positions', display_text: 'Show inactive hot positions' }
      ]
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getOutsourcePositions({
        env: this.env,
        ...this.filters_helper.getServerCallFilters(this.filters)
      }).then(response => {
        this.data = response
        this.sortOutsourcePositions()
        this.data.map(outsource_position => {
          outsource_position.priority = this.getPriorityTextByValue(outsource_position.priority)
          outsource_position.shuffle_position_id = outsource_position.id
          outsource_position.id = outsource_position.env_position_id
          outsource_position.env = this.env
        })
        this.addActiveSlotRecognizer()
      })
    },
    expire (data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Expire ' + data.title,
        item_name: data.title,
        method: 'updateOutsourcePosition',
        method_params: { env_position_id: data.env_position_id, status: 'expired', env: this.env }
      })
    },
    sortOutsourcePositions () {
      this.data.sort((a, b) => {
        let a_time = new Date(a.created_at).getTime()
        let b_time = new Date(b.created_at).getTime()
        return ((b.has_active_slot - a.has_active_slot) || ((b.priority * 1) - (a.priority * 1)) || (b_time - a_time))
      })
    },
    getPriorityTextByValue (value) {
      if (value == '2') {
        return 'עדיפות נמוכה'
      }
      if (value == '5') {
        return 'עדיפות בינונית'
      }
      if (value == '10') {
        return 'עדיפות גבוהה'
      }
      if (value == '60') {
        return 'BOOSTED'
      }
      return ''
    },
    addActiveSlotRecognizer () {
      this.data.map(outsource_position => {
        if (outsource_position.has_active_slot) {
          outsource_position.status = '🍏 ' + outsource_position.status
        }
      })
    },
    editClick (data) {
      this.create({
        designator: 'edit-outsource-position-form-modal',
        component_name: 'OutsourcePositionForm',
        shuffle_position_id: data.shuffle_position_id,
        env_position_id: data.env_position_id,
        position_applicant_code: data.position_applicant_code,
        modal_title: data.title
      })
    },
    showInactiveHotPositions () {
      this.create({
        designator: 'inactive-outsource-hot-positions',
        component_name: 'InactiveOutsourceHotPositions',
        modal_title: 'Inactive Outsource Hot Positions'
      })
    },
    showSlots (data) {
      this.create({
        designator: 'position-slots-modal',
        component_name: 'PositionSlotsModal',
        modal_width: 900,
        payload: {
          position: data,
          onSuccess: () => {
            this.init()
          }
        },
        modal_title: 'Slots - ' + data.title
      })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
